export interface WarehouseDelivery {
  id: number;
  po_number: string;
  po_delivery_status: string | null;
  assigned_driver: string;
  vehicle_number: string | null;
  leg_status: string | null;
  current_leg: number | null;
  leg_count: number | null;
  leg_commited_dispatch_time: string | null;
  leg_commited_delivery_time: string | null;
  leg_destination_warehouse: number | null;
  leg_origin_warehouse: number | null;
  can_receive: boolean;
  can_dispatch: boolean;
  is_search_hit?: boolean;
}

/** A P2P delivery has exactly one leg and is currently on that leg. */
export const isP2P = (row: { leg_count: number | null; current_leg: number | null }): boolean =>
  row.leg_count === 1 && row.current_leg === 1;

/**
 * Whether a row belongs in the incoming view for a given warehouse.
 * P2P rows always match — they have no fixed destination in the filter.
 * Multi-leg rows match only when their destination equals the selected warehouse.
 */
export const matchesIncomingWarehouse = (row: WarehouseDelivery, warehouseId: number): boolean =>
  isP2P(row) || row.leg_destination_warehouse === warehouseId;

export type WarehouseDirection = "incoming" | "outgoing";

export interface WarehouseDef {
  id: number;
  label: string;
}

export const WAREHOUSES: WarehouseDef[] = [
  { id: 578, label: "Rebound Exports" },
  { id: 721, label: "Horamavu Exports" },
  { id: 881, label: "Rampura Exports" },
  { id: 722, label: "Hyderabad Exports" },
];

export const OUTGOING_LEG_STATUSES = [
  "dispatch_pending",
  "pickup_attempted",
  "delivery_attempted",
];

export const deriveDirectionFromStatus = (leg_status: string | null): WarehouseDirection =>
  leg_status && OUTGOING_LEG_STATUSES.includes(leg_status) ? "outgoing" : "incoming";

export const warehouseLabel = (id: number | null | undefined): string =>
  WAREHOUSES.find((w) => w.id === id)?.label ?? (id != null ? String(id) : "-");
